const arrowSideSVG = `
    <?xml version="1.0" encoding="utf-8"?>
    <!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="48.193px" height="89.463px" viewBox="0 0 48.193 89.463" enable-background="new 0 0 48.193 89.463" xml:space="preserve">
    <g id="Layer_1">
    </g>
    <g id="LiveTXT" display="none">
    </g>
    <g id="GRids">
    <g>
    <g>
    <path fill="#250E47" d="M8.309,44.752L47.186,5.876c1.343-1.344,1.343-3.523,0-4.868c-1.345-1.343-3.524-1.343-4.868,0
    L1.007,42.318c-1.343,1.345-1.343,3.524,0,4.868l41.311,41.31c1.367,1.32,3.547,1.283,4.868-0.085
    c1.288-1.334,1.288-3.448,0-4.782L8.309,44.752z"/>
    </g>
    </g>
    </g>
    </svg>
`;

export default arrowSideSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/arrowSideSVG.js